<template>
  <div class="articlelistcontainer">
    <div class="article-title">{{ tableData.title }}</div>
    <div class="article-info">
      <div class="article-from">责任编辑：{{ tableData.auth }}</div>
      <div class="article-updatetime">更新时间：{{ tableData.updatetime }}</div>
      <div style="clear: both"></div>
    </div>
    <div class="article-content" v-html="tableData.content"></div>
  </div>
</template>

<script>
export default {
  created() {
    this.articleID = this.$route.params.id;
  },
  name: "ArticleList",

  data() {
    return {
      articleID: 0,
      tableData: [],
    };
  },
  methods: {
    tableRowClassName() {},
  },
  mounted() {
    const url = "http://www.heyuemedical.com/Article/?id=" + this.articleID;
    this.axios.get(url).then((res) => {
      this.tableData = res.data;
     });
  },
};
</script>

<style>
.articlelistcontainer {
  width: 1200px;
  margin: 0 auto;
  min-height: 500px;
  /*background-color: #eee;*/
}
td,
th {
  font-size: 16px;
}
.article-info {
  font-size: 16px;
  padding: 15px 30px;
  background-color: #eee;
  border-radius: 5px;
}
.article-updatetime {
  float: right;
}
.article-from {
  float: left;
}
.article-title {
  padding: 30px 0;
  font-size: 28px;
  font-weight:bold;
  font-family: 微软雅黑;
}
.article-content {
  text-align: left;
  font-size: 18px;
  line-height: 227%;
  text-indent: 2em;
  font-family:微软雅黑;
  font-weight:lighter;
  text-align: justify;
}
</style>

